import { DocumentBuiltinFlag, DocumentBuiltinFlagDict, DocumentBuiltinFlagsSettings } from '../document-builtin-flags';
import { DocumentStatus, DocumentStatusSystem, DocumentStatusSystems } from '../models/document-status.model';
import { SalesDocument } from '../models/sales-document.model';

export class DocumentStatusService {



    static determineStatus(
        changedField: keyof SalesDocument,
        document: SalesDocument,
        statusSystems: DocumentStatusSystems
    ) {
        let status = statusSystems[document.salesDocumentTypeId].statuses.find(el => el.id === Number(document.statusId));
        const flagsMatch = DocumentStatusService.matchFlags(status, document);
        if (!flagsMatch) {
            status = statusSystems[document.salesDocumentTypeId].statuses.find(el => DocumentStatusService.matchFlags(el, document))
        }
        return status;
    }

    static matchFlags(status: DocumentStatus, document: SalesDocument) {
        if (!status) {
            return false;
        }
        return status.flagCombination.some(combination => {
            let match = true;
            for (const flag in combination) {
                if (Object.prototype.hasOwnProperty.call(document, flag) || DocumentBuiltinFlagDict[flag]) {
                    if (combination[flag] === '1' && !document[flag]) {
                        match = false;
                        break;
                    } else if (combination[flag] === '0' && document[flag] == true) {
                        match = false;
                        break;
                    }
                } else {
                    if (combination[flag] === '1' && !document.flags?.[flag]) {
                        match = false;
                        break;
                    } else if (combination[flag] === '0' && document.flags?.[flag] == true) {
                        match = false;
                        break;
                    }
                }
            }
            return match;
        });
    }

    static determineFlags(
        changedField: keyof SalesDocument,
        document: SalesDocument,
        statusSystems: DocumentStatusSystems
    ) {
        const status = statusSystems[document.salesDocumentTypeId].statuses.find(el => el.id === Number(document.statusId));
        const flagsMatch = DocumentStatusService.matchFlags(status, document);
        const documentBuildInFlags: Record<string, boolean> = {};
        const documentFlags: Record<string, boolean> = {};
        if (!flagsMatch && status) {
            for (const flag in status.flagCombination[0]) {
                if (Object.prototype.hasOwnProperty.call(document, flag) || DocumentBuiltinFlagDict[flag]) {
                    if (status.flagCombination[0][flag] === '1') {
                        documentBuildInFlags[flag] = true;
                    } else if (status.flagCombination[0][flag] === '0') {
                        documentBuildInFlags[flag] = false;
                    }
                } else {
                    if (status.flagCombination[0][flag] === '1') {
                        documentFlags[flag] = true;
                    } else if (status.flagCombination[0][flag] === '0') {
                        documentFlags[flag] = false;
                    }
                }
            }
        }
        return {
            documentBuildInFlags,
            documentFlags,
        };
    }

    static getAvailableStatuses(
        document: SalesDocument,
        statusSystems: DocumentStatusSystems,
        side: 'seller' | 'buyer'
    ): DocumentStatus[] {
        const availableStatuses: DocumentStatus[] = [];
        const allStatuses = statusSystems[document.salesDocumentTypeId].statuses;
        const allFlags = statusSystems[document.salesDocumentTypeId].flags;

        for (const status of allStatuses) {
            let availableStatus = true;
            for (const flagCode in status.flagCombination[0]) {
                if (Object.prototype.hasOwnProperty.call(document, flagCode) || DocumentBuiltinFlagDict[flagCode]) {
                    const flag = {
                        canBuyerActivate: false,
                        canBuyerDeactivate: false,
                        canSellerActivate: false,
                        canSellerDeactivate: false,
                        ...DocumentBuiltinFlagsSettings[flagCode]
                    };
                    if (status.flagCombination[0][flagCode] === '1' && !document[flagCode]) {
                        availableStatus = availableStatus && (side === 'seller' ? flag.canSellerActivate : flag.canBuyerActivate);
                    } else if (status.flagCombination[0][flagCode] === '0' && document[flagCode] == true) {
                        availableStatus = availableStatus && (side === 'seller' ? flag.canSellerDeactivate : flag.canBuyerDeactivate);
                    }
                } else {
                    const flag = allFlags.find((el) => el.code === flagCode);
                    if (flag) {
                        if (status.flagCombination[0][flagCode] === '1' && !document.flags?.[flagCode]) {
                            availableStatus = availableStatus && (side === 'seller' ? flag.canSellerActivate : flag.canBuyerActivate);
                        } else if (status.flagCombination[0][flagCode] === '0' && document.flags?.[flagCode] == true) {
                            availableStatus = availableStatus && (side === 'seller' ? flag.canSellerDeactivate : flag.canBuyerDeactivate);
                        }
                    }
                }
            }
            if (availableStatus) {
                availableStatuses.push(status);
            }
        }

        return availableStatuses;
    }
}
